import React from "react";

export interface SystemHealthIconProps {
  color?: string;
  size?: number;
}

export const SystemHealthIcon: React.FC<SystemHealthIconProps> = ({
  color = "white",
  size = 24,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="icon">
      <path
        id="Vector"
        d="M9 12H12M15 12H12M12 12V9M12 12V15"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        id="Vector_2"
        d="M7 3.33782C8.47087 2.48697 10.1786 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 10.1786 2.48697 8.47087 3.33782 7"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        id="Vector_3"
        d="M2.5 5C2.5 3.61929 3.61929 2.5 5 2.5C6.38071 2.5 7.5 3.61929 7.5 5C7.5 6.38071 6.38071 7.5 5 7.5C3.61929 7.5 2.5 6.38071 2.5 5Z"
        stroke={color}
        strokeWidth="1.5"
      />
    </g>
  </svg>
);

export default SystemHealthIcon;
